import React from 'react';
import 'styles/donations/DonationList.css';
import 'styles/chat/MessageItem.css';
import TimeAgoCompact from 'util/TimeAgoCompact';
import {cancelCharityLinkRequest} from "../../util/api";

const DonationCard = ({donation, isAdmin = false}) => {
    const formatLink = (link) => {
        if (!/^https?:\/\//i.test(link)) {
            return `https://${link}`;
        }
        return link;
    };

    const getBaseDomain = (link) => {
        try {
            const url = new URL(formatLink(link));
            return url.hostname;
        } catch (e) {
            return link;
        }
    };

    const handleCancel = () => {
        cancelCharityLinkRequest(donation.id)
            .then(() => {
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error cancelling charity link:', error);
            });

    }

    return (
        <li className="donation-card">
            <div className="donation-header">
                <span className={`status-badge ${donation.status.toLowerCase()}`}>
                    {donation.status}
                </span>
            </div>
            {donation.charityName && (
                <div className="donation-detail">
                    <strong>Charity Name:</strong> {donation.charityName}
                </div>
            )}
            <div className="donation-detail">
                <strong>Badge:</strong> {donation.badgeId}
            </div>
            <div className="donation-detail">
                <strong>Link:</strong>{' '}
                <a
                    href={formatLink(donation.link)}
                    className="donation-link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {getBaseDomain(donation.link)}
                </a>
            </div>
            {donation.status === 'PENDING' && (
                <button className="donation-detail" onClick={handleCancel}>
                    CANCEL
                </button>
            )}
            <div className="time-ago">
                <TimeAgoCompact timestamp={donation.createdOn} cssName={'picture-comment-time-ago'} includeAgo={true}/>
            </div>
            {donation.status === 'Rejected' && (
                <div className="donation-detail rejection-reason">
                    <strong>Rejection Reason:</strong> {donation.rejectionReason}
                </div>
            )}
            {isAdmin && (
                <div className="donation-detail">
                    <div><strong>Link ID:</strong> {donation.rawData.id}</div>
                    <div><strong>Full Link:</strong>{donation.link}</div>
                    <div><strong>Username:</strong> {donation.rawData.sender?.username}</div>
                    <div><strong>Sender ID:</strong> {donation.rawData.sender?.id}</div>
                    <div><strong>Created On:</strong> {new Date(donation.rawData.createdOn).toLocaleString()}</div>
                    <div><strong>Publicly Visible:</strong> {donation.rawData.publiclyVisible ? 'Yes' : 'No'}</div>
                    <div><strong>Admin Category:</strong> {donation.rawData.adminCategory}</div>
                    <div><strong>Admin Rejection Reason:</strong> {donation.rawData.adminRejectionReason}</div>
                    <strong>Raw Data:</strong> {JSON.stringify(donation.rawData, null, 2)}
                </div>
            )}
        </li>
    );
};

export default DonationCard;